import { z } from 'zod'

/** Reusable schema for text inputs that must contain non-whitespace content. */
export const trimmedNonEmptyStringSchema = z.string().trim().nonempty()
